import userIsAuthenticated from "@store/Hooks/userIsAuthenticated";
import userIsRemembered from "@store/Hooks/userIsRemembered";

export const isAuthenticatedOrRemembered = () => {
    return userIsAuthenticated() || userIsRemembered();
};